import "./styles.css";
import * as THREE from "three";
import * as dat from "dat.gui";
import loadGrassTextures from "./config/GrassTexture";
import { loadCannonTextures } from "./config/CannonTextures";
// import { loadBaseTextures } from "./config/BaseTexures";
import Ball from "./physics/ball";
import { loadModels } from "./config/Models";
import { loadTargetTextues } from "./config/TargetTexure";
import { CylinderBufferGeometry, PlaneBufferGeometry } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
//import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import gsap from "gsap";
import World from "./physics/world";
import { loadFlagBaseTextures } from "./config/FlagBaseTextures";
import flagVertexShader from "./shaders/FlagSheders/vertex.glsl";
import flagFragmentShader from "./shaders/FlagSheders/fragment.glsl";
import { loadFlagTexture } from "./config/FlagTexture";
import { loadBallTextures } from "./config/BallTextures";
import vector from "./physics/vector";

/*
    Variables
*/
const gui = new dat.GUI();
gui.close();
let argument = window.matchMedia("(max-width: 425px)");
let fun = (argument) => {
  if (argument.matches) {
    gui.width = 150;
  } else {
    gui.width = 250;
  }
};
fun(argument);
argument.addListener(fun);
const worldfolder = gui.addFolder("world");
const ballFolder = gui.addFolder("ball");
const coefficientsFolder = ballFolder.addFolder("coefficients");
coefficientsFolder.open();
coefficientsFolder.hide();
worldfolder.open();
ballFolder.open();
let isClicked = false;
const size = {
  width: window.innerWidth,
  height: window.innerHeight,
};
const mouse = new THREE.Vector2();
const cannonDirection = new THREE.Vector3();
const scene = new THREE.Scene();
const GRAVITY = 9.8;
const HEIGHT = 0,
  TEMPERETURE = 15; // celsius
const WIND_SPEED = 10,
  WIND_ANGLE = Math.PI / 2;
const SHOOT_DELAY = 2000;
let lastShotingTime = 0;
let numberOfBalls = 20;
let successCount = 0; // Track successful kicks
let isObjectLoaded;
let intersectObjects = [];
let axesHelper;
let isFinished = false;
/*
    Paramters
*/
const paramters = {
  windSpeed: 10,
  windAngle: Math.PI / 2,
  angular_speedX: 0,
  angular_speedY: 1,
  angular_speedZ: 0,
  axesHelper: false,
  radius: 0.5,
  gravity: 9.8,
  dragCoeff: 0.47,
  height: 0,
  tempereture: 15,
  resistanseCoeff: 0.8,
  frictionCoeff: 0.8,
  mass: 1000,
  speed: 25,
};

/*
    Loaders
*/
const loadingBar = document.querySelector(".loadingBar");
const loadingManger = new THREE.LoadingManager(
  () => {
    gsap.delayedCall(0.5, () => {
      gsap.to(overlay.material.uniforms.uAlpha, { duration: 3, value: 0 });
      loadingBar.classList.add("ended");
      loadingBar.style.transform = "";
      document.querySelector(".screenInfo").classList.remove("hide");
    });
    isObjectLoaded = true;
  },
  (itemUrl, itemsLoaded, itemsTotal) => {
    loadingBar.style.transform = "scaleX(" + itemsLoaded / itemsTotal + ")";
  }
);
const gltfLoader = new GLTFLoader(loadingManger);
// const fbxLoader = new FBXLoader(loadingManger);
const textureLoader = new THREE.TextureLoader(loadingManger);

// Load ball GLB model
let ballGLBModel = null;
gltfLoader.load("models/ball/ball.glb", (gltf) => {
  ballGLBModel = gltf.scene;
  console.log("Ball GLB model loaded successfully");
}, undefined, (error) => {
  console.error("Error loading ball GLB model:", error);
});
// const audioLoader = new THREE.AudioLoader(loadingManger);
// audioLoader.load("sounds/cannonShootingSound.mp3", (audioBuffer) => {
//   shootingSoundEffect.setBuffer(audioBuffer);
// });

/*
    Game Screen
*/
const numberofBallsWidget = document.querySelector(".cannonBallsNumber");
numberofBallsWidget.innerHTML = numberOfBalls;

const scoreWidget = document.querySelector(".ScoreNumber");
scoreWidget.innerHTML = successCount;

// Remove target widget - no longer needed
// const targetWidget = document.querySelector(".targetNumbers");
// targetWidget.innerHTML = numberOfTargets;

const gameFinshed = document.querySelector(".gameFinshedLayout");

const playAgain = document.querySelector(".playAgain");
/*
    Configure Scene
*/
scene.fog = new THREE.Fog(0xcce0ff, 1300, 1600);
const texture = textureLoader.load("textures/skybox/FS002_Day.png", () => {
  const rt = new THREE.WebGLCubeRenderTarget(texture.image.height);
  rt.fromEquirectangularTexture(renderer, texture);
  scene.background = rt.texture;
});

/*
    Configure Pysics World
*/
const world = new World(GRAVITY, HEIGHT, TEMPERETURE, WIND_SPEED, WIND_ANGLE);

worldfolder
  .add(paramters, "gravity", -10, 100, 0.1)
  .name("gravity")
  .onChange(() => {
    world.gravity = paramters.gravity;
  });

worldfolder
  .add(paramters, "windSpeed", 0, 100, 0.01)
  .name("Wind Speed")
  .onChange(() => {
    world.wind_speed = paramters.windSpeed;
  });
worldfolder
  .add(paramters, "windAngle", 0, 6.2831853072, 0.2)
  .name("Wind Angle")
  .onChange(() => {
    world.wind_angle = paramters.windAngle;
    rotateAboutPoint(
      flag,
      flagBase.position,
      new THREE.Vector3(0, 1, 0),
      paramters.windAngle
    );
  });
worldfolder
  .add(paramters, "height", -100, 1000, 10)
  .name("Height")
  .onChange(() => {
    world.height = paramters.height;
  });

worldfolder
  .add(paramters, "tempereture", -100, 100, 1)
  .name("Tempereture")
  .onChange(() => {
    world.tempereture = paramters.tempereture;
  });

/* 
    Tweak gui values
*/
ballFolder.add(paramters, "axesHelper");
ballFolder.add(paramters, "radius", 0, 1, 0.01).name("ball radius");
// let massController = ballFolder
//   .add(paramters, "mass", 1, 5000, 0.5)
//   .name("ball mass");
ballFolder.add(paramters, "speed", 10, 35, 0.1).name("ball speed");
ballFolder
  .add(paramters, "angular_speedX", -10, 10, 0.1)
  .name("Angular speed X");
ballFolder
  .add(paramters, "angular_speedY", -10, 10, 0.1)
  .name("Angular speed Y");
ballFolder
  .add(paramters, "angular_speedZ", -10, 10, 0.1)
  .name("Angular speed Z");

coefficientsFolder.add(paramters, "dragCoeff", 0, 1, 0.001).name("dragCoeff");
coefficientsFolder
  .add(paramters, "resistanseCoeff", 0, 1, 0.001)
  .name("resistanseCoeff");
coefficientsFolder
  .add(paramters, "frictionCoeff", 0, 1, 0.001)
  .name("frictionCoeff");
/*
    Textures
*/
const grassTextures = loadGrassTextures(textureLoader);
const cannonTextures = loadCannonTextures(textureLoader);
// const baseTextures = loadBaseTextures(textureLoader);
const targetTextures = loadTargetTextues(textureLoader);
const flagBaseTexutes = loadFlagBaseTextures(textureLoader);
const flagTextures = loadFlagTexture(textureLoader);
const ballTextures = loadBallTextures(textureLoader);
paramters.ballTextures = ballTextures[0];

/* 
    Models
*/
// loadModels(scene, gltfLoader, intersectObjects);
loadModels(scene, intersectObjects);

/*
    Events
*/
gui.domElement.addEventListener("mousedown", () => (isClicked = true));
gui.domElement.addEventListener("mouseleave", () => (isClicked = false));
window.addEventListener("mouseup", () => checkGame());
window.addEventListener("dblclick", () => {
  const fullScreen =
    document.fullscreenElement || document.webkitFullscreenElement;
  if (!fullScreen) {
    if (canvas.requestFullscreen) {
      canvas.requestFullscreen();
    } else if (canvas.webkitRequestFullscreen) {
      canvas.webkitRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  }
});


// Update mouse position for cannon aiming (only when not dragging)
window.addEventListener("mousemove", (event) => {
  if (!isDragging) {
    mouse.x = event.pageX / size.width;
    mouse.y = event.pageY / size.height;
  }
});
window.addEventListener("touchmove", (event) => {
  if (!isDragging) {
    event.preventDefault();
    mouse.x = event.touches[0].clientX / size.width;
    mouse.y = event.touches[0].clientY / size.height;
  }
});


// Shooting function to avoid code duplication
const handleShooting = () => {
  console.log('=== SHOOTING ATTEMPT ===');
  console.log('Device info:', { isMobile, isSafari, userAgent: navigator.userAgent });
  
  // Update cannon direction before shooting to ensure proper aim
  updateCannon();
  
  // Debug: Log all shooting conditions
  const conditions = {
    notClicked: !isClicked,
    notFinished: !isFinished,
    notShootingInProgress: !isShootingInProgress,
    noBallsInFlight: objectsToUpdate.length === 0,
    objectLoaded: isObjectLoaded,
    hasBalls: numberOfBalls > 0,
    hasTargets: true, // Always allow shooting
    shootDelayPassed: window.performance.now() - lastShotingTime > SHOOT_DELAY,
    mousePosition: { x: mouse.x, y: mouse.y },
    cannonAngles: { angleXY, angleXZ },
    currentTime: window.performance.now(),
    lastShootingTime: lastShotingTime,
    timeSinceLastShot: window.performance.now() - lastShotingTime
  };
  
  console.log('Shooting conditions:', conditions);
  
  // If there are stuck balls, clean them up first
  if (objectsToUpdate.length > 0) {
    console.log('Found stuck balls, cleaning up...');
    cleanupStuckBalls();
  }
  
  // Check if we can shoot
  const canShoot = (
    !isClicked &&
    !isFinished &&
    !isShootingInProgress && // Prevent shooting if already in progress
    objectsToUpdate.length === 0 && // Only allow shooting if no balls are in flight
    isObjectLoaded &&
    numberOfBalls > 0 &&
    window.performance.now() - lastShotingTime > SHOOT_DELAY
  );
  
  // Safari fallback: only use for Safari on mobile devices
  const safariFallback = isSafari && isMobile && !canShoot && numberOfBalls > 0 && isObjectLoaded;
  
  console.log('Can shoot:', canShoot, 'Safari fallback:', safariFallback);
  
  if (canShoot || safariFallback) {
    if (safariFallback) {
      console.log('Using Safari fallback - forcing shot');
      // Clean up any stuck balls for Safari
      if (objectsToUpdate.length > 0) {
        cleanupStuckBalls();
      }
      // Reset shooting lock for Safari
      isShootingInProgress = false;
    }
    
    isClicked = false;
    // shootingSoundEffect.play();
    console.log('Starting shot - objectsToUpdate length:', objectsToUpdate.length, 'isShootingInProgress:', isShootingInProgress);
    createCannonBall();
    let zPosition = cannon.position.z;
    gsap.to(cannon.position, {
      duration: 1.5,
      delay: 0.2,
      z: cannon.position.z + 8, // Reduced recoil for shorter distance
    });
    gsap.delayedCall(0.2, () => {
      gsap.to(cannon.position, { duration: 1.5, delay: 0.2, z: zPosition });
    });
    // Camera tracking removed - camera will stay in fixed position
    lastShotingTime = window.performance.now();
  } else {
    console.log('Cannot shoot - conditions not met');
  }
};

// Detect if we're on a mobile device
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

console.log('Device detection:', { isMobile, isSafari });

// Drag gesture variables
let dragStartPosition = { x: 0, y: 0 };
let isDragging = false;
let dragDistance = 0;
const MIN_DRAG_DISTANCE = 30; // Minimum pixels to drag before ball kicks

// Cannon positioning variables
let previousCannonPosition = new THREE.Vector3(0, 10, 330); // Initial cannon position
const MIN_CANNON_DISTANCE = 25; // Minimum distance between old and new cannon positions (reduced for smaller bounds)
const MAX_ATTEMPTS = 10; // Maximum attempts to find a valid position

// Cannon positioning bounds (to keep cannon within reasonable area)
// Camera is at (0, 10, 370), target at (0, 30, -150)
// Original barrel at (0, 10, 330) - this should be our center reference
const CANNON_BOUNDS = {
  xMin: -30,  // Left boundary (reduced from -60)
  xMax: 30,   // Right boundary (reduced from 60)
  yMin: 8,    // Minimum height (close to original 10)
  yMax: 15,   // Maximum height (reduced from 25)
  zMin: 320,  // Closest to camera (camera is at 370)
  zMax: 350   // Farthest from camera (reduced from 380)
};

// Drag start handler
const handleDragStart = (event) => {
  console.log('Drag start event:', event.type, event);
  
  // Prevent default for touch events
  if (event.type === 'touchstart' || (event.type === 'pointerdown' && event.pointerType !== "mouse")) {
    event.preventDefault();
  }
  
  // Get start position
  let clientX, clientY;
  if (event.type === 'touchstart' && event.touches && event.touches.length > 0) {
    clientX = event.touches[0].clientX;
    clientY = event.touches[0].clientY;
  } else if (event.type === 'pointerdown') {
    clientX = event.clientX;
    clientY = event.clientY;
  } else if (event.type === 'mousedown') {
    clientX = event.clientX;
    clientY = event.clientY;
  }
  
  dragStartPosition = { x: clientX, y: clientY };
  isDragging = true;
  dragDistance = 0;
  
  console.log('Drag started at:', dragStartPosition);
};

// Drag move handler
const handleDragMove = (event) => {
  if (!isDragging) return;
  
  // Prevent default for touch events
  if (event.type === 'touchmove' || (event.type === 'pointermove' && event.pointerType !== "mouse")) {
    event.preventDefault();
  }
  
  // Get current position
  let clientX, clientY;
  if (event.type === 'touchmove' && event.touches && event.touches.length > 0) {
    clientX = event.touches[0].clientX;
    clientY = event.touches[0].clientY;
  } else if (event.type === 'pointermove') {
    clientX = event.clientX;
    clientY = event.clientY;
  } else if (event.type === 'mousemove') {
    clientX = event.clientX;
    clientY = event.clientY;
  }
  
  // Calculate drag distance
  const deltaX = clientX - dragStartPosition.x;
  const deltaY = clientY - dragStartPosition.y;
  dragDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  
  console.log('Drag distance:', dragDistance);
};

// Drag end handler
const handleDragEnd = (event) => {
  console.log('Drag end event:', event.type, event);
  
  if (!isDragging) return;
  
  // Prevent default for touch events
  if (event.type === 'touchend' || (event.type === 'pointerup' && event.pointerType !== "mouse")) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  // Get end position
  let clientX, clientY;
  if (event.type === 'touchend' && event.changedTouches && event.changedTouches.length > 0) {
    clientX = event.changedTouches[0].clientX;
    clientY = event.changedTouches[0].clientY;
  } else if (event.type === 'pointerup') {
    clientX = event.clientX;
    clientY = event.clientY;
  } else if (event.type === 'mouseup') {
    clientX = event.clientX;
    clientY = event.clientY;
  }
  
  // Calculate final drag distance
  const deltaX = clientX - dragStartPosition.x;
  const deltaY = clientY - dragStartPosition.y;
  dragDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  
  console.log('Final drag distance:', dragDistance);
  
  // Only shoot if drag distance is sufficient
  if (dragDistance >= MIN_DRAG_DISTANCE) {
    // Update mouse position to end position for ball direction
    mouse.x = clientX / size.width;
    mouse.y = clientY / size.height;
    console.log('Ball direction set to:', mouse.x, mouse.y);
    
    // Add a small delay for Safari to ensure proper event handling
    if (isSafari && (event.type === 'touchend' || event.type === 'pointerup')) {
      setTimeout(() => {
        handleShooting();
      }, 50);
    } else {
      handleShooting();
    }
  } else {
    console.log('Drag distance too small, no ball kicked');
  }
  
  // Reset drag state
  isDragging = false;
  dragDistance = 0;
};

// Mouse drag events (for desktop)
window.addEventListener("mousedown", handleDragStart);
window.addEventListener("mousemove", handleDragMove);
window.addEventListener("mouseup", handleDragEnd);

// Touch events for mobile devices
if (isMobile || isSafari) {
  window.addEventListener("touchstart", handleDragStart, { passive: false });
  window.addEventListener("touchmove", handleDragMove, { passive: false });
  window.addEventListener("touchend", handleDragEnd, { passive: false });
}

// Pointer events for better cross-platform compatibility
if (isMobile) {
  window.addEventListener("pointerdown", handleDragStart, { passive: false });
  window.addEventListener("pointermove", handleDragMove, { passive: false });
  window.addEventListener("pointerup", handleDragEnd, { passive: false });
}
// Play Again button handler
const handlePlayAgain = () => {
  console.log('Play Again clicked - hiding modal and starting new round');
  gameFinshed.classList.add("hide");
  // Reset for new round
  successCount = 0;
  numberOfBalls = 20;
  scoreWidget.innerHTML = successCount;
  numberofBallsWidget.innerHTML = numberOfBalls;
  
  // Reset ball removal flag (simplified)
  isShootingInProgress = false; // Reset shooting lock
  if (shootingLockTimeout) {
    clearTimeout(shootingLockTimeout);
    shootingLockTimeout = null;
  }
  
  // Reset target to default state
  if (target) {
    target.material.color.set("#ffffff");
    if (!intersectObjects.includes(target)) {
      intersectObjects.push(target);
    }
  }
  
  console.log('New round started! Balls: 20, Success: 0');
  setTimeout(() => (isFinished = false), 1000);
};

// New function to show results modal
const showResultsModal = () => {
  console.log('Showing results modal...');
  gameFinshed.classList.remove("hide");
  let status = document.querySelector(".status");
  status.innerHTML = `You scored ${successCount} out of 20 balls`;
  status.style.color = "#346751";
  
  // Update play again button text
  let playAgainButton = document.querySelector(".playAgain");
  if (playAgainButton) {
    playAgainButton.innerHTML = "Play Again";
  }
  
  console.log(`Round completed! Success: ${successCount}/20 balls`);
};

// Play Again button events for both mouse and touch
playAgain.addEventListener("mousedown", handlePlayAgain);
playAgain.addEventListener("touchend", (event) => {
  event.preventDefault();
  handlePlayAgain();
});
playAgain.addEventListener("pointerup", (event) => {
  if (event.pointerType !== "mouse") {
    event.preventDefault();
    handlePlayAgain();
  }
});

/* 
    Cameras
*/
let isCameraChasing = false;
const camera = new THREE.PerspectiveCamera(
  45,
  size.width / size.height,
  0.1,
  1600
);
camera.position.set(0, 10, 370); // Adjusted for shorter distance (was 740, now 370)
camera.lookAt(new THREE.Vector3(0, 30, -150)); // Look at the target position initially
scene.add(camera);
const chasingCamera = new THREE.PerspectiveCamera(
  45,
  size.width / size.height,
  0.1,
  1600
);
chasingCamera.position.set(0, 10, 0);
scene.add(chasingCamera);

/*
    Sounds
*/
// const audioListener = new THREE.AudioListener();
// camera.add(audioListener);
// chasingCamera.add(audioListener);
// const shootingSoundEffect = new THREE.Audio(audioListener);
// scene.add(shootingSoundEffect);

/*
    Lights
*/
const ambientLight = new THREE.AmbientLight("white", 0.75);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight("white", 0.35);
directionalLight.position.copy(new THREE.Vector3(-84.5, 169.1, 696));
scene.add(directionalLight);

/*
    Objects
*/
// ------------------ Add the shooting object ----------------------
const cannon = new THREE.Group();
scene.add(cannon);
const metalMaterial = new THREE.MeshStandardMaterial({
  map: cannonTextures.cannonColorTexture,
  aoMap: cannonTextures.cannonAmbientOcclusionTexture,
  roughnessMap: cannonTextures.cannonRoughnessTexture,
  normalMap: cannonTextures.cannonNormalTexture,
  metalnessMap: cannonTextures.cannonMetalnessTexture,
});
const barrel = new THREE.Mesh(
  new THREE.CylinderBufferGeometry(5, 3, 20, 32, 1, true, Math.PI * 2),
  metalMaterial
);
barrel.position.set(0, 10, 330); // Half distance from target (was 660, now 330)
barrel.rotation.x = (-Math.PI / 4) * 1.5;
barrel.material.roughness = 0.5;
barrel.material.side = THREE.DoubleSide;
// cannon.add(barrel);

// Create ball model using GLB model
let ballModel = null;

// Function to create ball model from GLB
const createBallModel = () => {
  if (ballGLBModel) {
    // Clone the GLB model to avoid modifying the original
    ballModel = ballGLBModel.clone();
    
    // Apply appropriate scale for the ball
    ballModel.scale.set(2, 2, 2); // Adjust scale as needed
    
    // Apply initial Z-axis rotation to the quaternion for proper orientation
    const initialRotation = new THREE.Quaternion();
    initialRotation.setFromAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2); // 90 degrees around Z-axis
    ballModel.quaternion.copy(initialRotation);
    
    // Position the ball model at the same location as the cannon ball
    ballModel.position.copy(
      barrel.position.clone().add(new THREE.Vector3(0, -8.5, -1))
    );
    
    // Enable shadows
    ballModel.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    
    cannon.add(ballModel);
    console.log("Ball GLB model added to cannon");
  } else {
    console.warn("Ball GLB model not loaded yet, will retry...");
    // Retry after a short delay
    setTimeout(createBallModel, 100);
  }
};

// Create the ball model
createBallModel();

// Function to ensure ball model is properly visible and positioned
const ensureBallModelVisible = () => {
  if (ballModel) {
    // Ensure ball model is in the scene
    if (!ballModel.parent) {
      cannon.add(ballModel);
      console.log('Ball model added back to cannon');
    }
    
    // Update position to match cannon and ensure visibility
    const ballPosition = barrel.position.clone().add(new THREE.Vector3(0, -8.5, -1));
    // Ensure ball is always above ground level (field is at y=0)
    ballPosition.y = Math.max(ballPosition.y, 2); // Minimum 2 units above ground
    ballModel.position.copy(ballPosition);
    
    // Make it visible
    ballModel.visible = true;
  }
};

// Ensure ball model is visible initially and properly positioned
ensureBallModelVisible();

// Force initial ball model positioning to ensure proper alignment and visibility
if (ballModel) {
  const initialBallPosition = barrel.position.clone().add(new THREE.Vector3(0, -8.5, -1));
  // Ensure ball is always above ground level (field is at y=0)
  initialBallPosition.y = Math.max(initialBallPosition.y, 2); // Minimum 2 units above ground
  ballModel.position.copy(initialBallPosition);
  console.log('Initial ball model position set to:', ballModel.position);
}

// Initialize cannon position tracking
previousCannonPosition.copy(barrel.position);
console.log('Initial cannon position set to:', previousCannonPosition);

const cannonCover = new THREE.Mesh(
  new THREE.SphereBufferGeometry(3, 32, 32),
  metalMaterial
);
cannonCover.position.y = -10;
cannonCover.material.roughness = 0.5;
barrel.add(cannonCover);

// ------------------ Add the playground ----------------------
// Create floor that extends forward to fill the gap in front of the camera
// Camera is at z = 740, so field needs to extend much further forward
// Boundaries: x: -150 to 270 (width: 420), z: -225 to 800 (extended length: 1025)
const playgroundWidth = 420;  // From -150 to 270
const playgroundLength = 1025; // Extended from -225 to 800 to fill front gap
const playgroundCenterX = 60; // Center between -150 and 270
const playgroundCenterZ = 287.5; // Center between -225 and 800

const floor = new THREE.Mesh(
  new THREE.PlaneBufferGeometry(playgroundWidth, playgroundLength, 50, 50),
  new THREE.MeshStandardMaterial({
    map: grassTextures.grassColorTexture,
    aoMap: grassTextures.grassAmbientOcclusionTexture,
    displacementMap: grassTextures.grassHeightTexture,
    metalnessMap: grassTextures.grassMetalnessTexture,
    displacementScale: 0.0,
    normalMap: grassTextures.grassNormalTexture,
    roughnessMap: grassTextures.grassRoughnessTexture,
  })
);
floor.material.roughness = 0.5;
floor.geometry.setAttribute(
  "uv2",
  new THREE.Float32BufferAttribute(floor.geometry.attributes.uv.array, 2)
);
floor.rotation.x = -Math.PI / 2;
floor.position.set(playgroundCenterX, 0, playgroundCenterZ);
scene.add(floor);

const flagBase = new THREE.Mesh(
  new CylinderBufferGeometry(1, 1, 35, 32),
  new THREE.MeshStandardMaterial({
    map: flagBaseTexutes.flagBaseColorTexture,
    aoMap: flagBaseTexutes.flagBaseAmbientOcclusionTexture,
    normalMap: flagBaseTexutes.flagBaseNormalTexture,
    roughnessMap: flagBaseTexutes.flagBaseRoughnessTexture,
  })
);
flagBase.geometry.setAttribute(
  "uv2",
  new THREE.Float32BufferAttribute(flagBase.geometry.attributes.uv.array, 2)
);
flagBase.position.copy(new THREE.Vector3(60, 14, 578.1));
// scene.add(flagBase);

const flagGeometry = new PlaneBufferGeometry(13, 13, 32, 32);
const flagMaterial = new THREE.ShaderMaterial({
  vertexShader: flagVertexShader,
  fragmentShader: flagFragmentShader,
  side: THREE.DoubleSide,
  uniforms: {
    uFrequency: { value: new THREE.Vector2(1.04, 2.56) },
    uTime: { value: 0 },
    uColor: { value: new THREE.Color("orange") },
    uTexture: { value: flagTextures.flagColorTexture },
  },
});
const flag = new THREE.Mesh(flagGeometry, flagMaterial);
flag.position.copy(flagBase.position.clone().add(new THREE.Vector3(-4, 12, 0)));
flag.position.x = 52.889;
flag.position.y = 25.928;
flag.scale.y = 2 / 3;
// scene.add(flag);

// Create the visual target (red back of goal)
let target = new THREE.Mesh(
  new THREE.PlaneGeometry(35, 60),
  new THREE.MeshStandardMaterial({
    map: targetTextures.targetColorTexture,
    alphaTest: 0.1,
  })
);
target.position.set(0, 30, -150);
scene.add(target);
intersectObjects.push(target);

// No separate collision objects needed - we'll use only the target for collision detection
// The target itself will determine success/failure based on hit position

// Target is already added to intersectObjects, no additional collision setup needed
/*
    Overlay
*/
const overlay = new THREE.Mesh(
  new PlaneBufferGeometry(2, 2, 1, 1),
  new THREE.ShaderMaterial({
    transparent: true,
    uniforms: {
      uAlpha: { value: 1 },
    },
    vertexShader: `
        void main()
        {
            gl_Position =  vec4(position ,1.0);
        }
        `,
    fragmentShader: `
        uniform float uAlpha;
        void main() 
        {
            gl_FragColor = vec4(0.0 , 0.0 , 0.0 , uAlpha);
        }
        `,
  })
);
scene.add(overlay);

/*
    Reycaster
*/
const raycaster = new THREE.Raycaster();
raycaster.far = 20;
raycaster.near = 2;
let rayOrigin;
let rayDirection = new THREE.Vector3(0, 0, -10);
rayDirection.normalize();

/*
    Renderer
*/
const canvas = document.querySelector(".webgl");
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(size.width, size.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.physicallyCorrectLights = true;

// Prevent touch scrolling on the canvas to avoid interference with game input
canvas.addEventListener("touchstart", (event) => {
  event.preventDefault();
}, { passive: false });

canvas.addEventListener("touchmove", (event) => {
  event.preventDefault();
}, { passive: false });

canvas.addEventListener("touchend", (event) => {
  event.preventDefault();
}, { passive: false });

/*
    Shadows
*/
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFShadowMap;
directionalLight.shadow.camera.near = 1;
directionalLight.shadow.camera.far = 450;
directionalLight.shadow.camera.right = 200;
directionalLight.shadow.camera.left = -200;
directionalLight.shadow.camera.top = 200;
directionalLight.shadow.camera.bottom = -200;
directionalLight.shadow.mapSize.x = 1024;
directionalLight.shadow.mapSize.y = 1024;

directionalLight.castShadow = true;
floor.receiveShadow = true;
barrel.castShadow = true;
// base.receiveShadow = true;

/*
    Utils
*/
const lerp = (a, b, t) => a + (b - a) * t;

let angleXY, angleXZ;

// Update the camera view angle part
const updateCannon = () => {
  barrel.rotation.z = -lerp(-Math.PI / 4, Math.PI / 4, mouse.x);
  barrel.rotation.x = -lerp(Math.PI / 8, Math.PI / 2, mouse.y);
  cannonDirection.set(0, 1, 0);
  cannonDirection.applyQuaternion(barrel.quaternion);
  
  camera.position.set(0, 15, 390);
  camera.lookAt(new THREE.Vector3(0, 30, 0));

  let vector = new THREE.Vector3();
  camera.getWorldDirection(vector);
  
  angleXY = Math.asin(cannonDirection.clone().y);
  angleXZ = Math.acos(cannonDirection.clone().x);
};

// Draw the Shooting ball-------------------
let objectsToUpdate = [];

// Add event listeners that reference objectsToUpdate, camera, and renderer
window.addEventListener("keydown", (event) => {
  if (event.code === "Digit2") {
    isCameraChasing = true;
  } else if (event.code === "Digit1") {
    isCameraChasing = false;
  } else if (event.code === "KeyR") {
    // Manual reset of shooting lock (for debugging)
    console.log('Manual reset of shooting lock');
    isShootingInProgress = false;
    if (shootingLockTimeout) {
      clearTimeout(shootingLockTimeout);
      shootingLockTimeout = null;
    }
  } else if (event.code === "KeyC") {
    // Manual cleanup of stuck balls (for debugging)
    console.log('Manual cleanup of stuck balls');
    cleanupStuckBalls();
  }
});

window.addEventListener("resize", () => {
  size.width = window.innerWidth;
  size.height = window.innerHeight;
  camera.aspect = size.width / size.height;
  chasingCamera.aspect = size.width / size.height;
  camera.updateProjectionMatrix();
  chasingCamera.updateProjectionMatrix();
  renderer.setSize(size.width, size.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});
const createCannonBall = () => {
  // Set shooting lock to prevent multiple balls
  isShootingInProgress = true;
  
  // Failsafe: Reset shooting lock after 5 seconds if it gets stuck
  if (shootingLockTimeout) {
    clearTimeout(shootingLockTimeout);
  }
  shootingLockTimeout = setTimeout(() => {
    if (isShootingInProgress) {
      console.warn('Shooting lock was stuck - resetting it');
      isShootingInProgress = false;
    }
  }, 5000);
  
  removeBallsGreaterThanOne();
  numberOfBalls--;
  numberofBallsWidget.innerHTML = numberOfBalls;
  
  // Don't check game immediately - wait for ball action to finish
  // Game will be checked in tick() when objectsToUpdate.length === 0
  
  // Reset target model to default state when starting new shot
  if (target) {
    target.material.color.set("#ffffff"); // Reset to white
    // Ensure target is in intersectObjects for collision detection
    if (!intersectObjects.includes(target)) {
      intersectObjects.push(target);
    }
  }
  
  // Reset shot tracking for new shot
  shotedTaregt = [];
  
  // Reset shot state for new shot
  currentShotState = 'none';
  
  // Reset goal prediction flag for new shot
  goalPredictionActive = false;
  
  // Reset goal opening detection for new shot
  ballPassedThroughGoal = false;
  lastBallPosition = null;
  
  // Reset ball removal flag for new shot (simplified)
  
  // Reset boundary tracking for new shot (simplified)
  
  // Hide the ball model when shooting
  if (ballModel) {
    ballModel.visible = false;
    console.log('Ball model hidden when shooting');
  }
  // Create cannon ball using GLB model
  let cannonBall = null;
  
  if (ballGLBModel) {
    // Clone the GLB model for the cannon ball
    cannonBall = ballGLBModel.clone();
    
    // Apply appropriate scale for the cannon ball
    cannonBall.scale.set(2, 2, 2); // Adjust scale as needed
    
    // Apply initial Z-axis rotation to the quaternion for proper orientation
    const initialRotation = new THREE.Quaternion();
    initialRotation.setFromAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2); // 90 degrees around Z-axis
    cannonBall.quaternion.copy(initialRotation);

    // Enable shadows
    cannonBall.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    
    cannonBall.position.copy(
      barrel.position.clone().add(new THREE.Vector3(0, 2, -1))
    );
    scene.add(cannonBall);
  } else {
    // Fallback to manual sphere if GLB model is not loaded
    console.warn("Ball GLB model not loaded, using fallback sphere");
    const footballGeometry = new THREE.SphereGeometry(paramters.radius * 5, 32, 32);
    
    // Configure texture settings
    paramters.ballTextures.color.wrapS = THREE.RepeatWrapping;
    paramters.ballTextures.color.wrapT = THREE.RepeatWrapping;
    paramters.ballTextures.color.flipY = false;
    paramters.ballTextures.color.repeat.set(1, 1);
    
    cannonBall = new THREE.Mesh(
      footballGeometry,
      new THREE.MeshStandardMaterial({
        map: paramters.ballTextures.color,
        color: 0x8B4513, // Better brown color for football
        side: THREE.DoubleSide,
        transparent: false,
        roughness: 0.8,
        metalness: 0.0,
        normalMap: paramters.ballTextures.normal,
        roughnessMap: paramters.ballTextures.roughness,
      })
    );
    
    // Scale to make it football-shaped (this preserves UV mapping)
    cannonBall.scale.set(1.15, 0.65, 0.65);

    // Apply initial Z-axis rotation to the quaternion for proper orientation
    const initialRotation = new THREE.Quaternion();
    initialRotation.setFromAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2); // 90 degrees around Z-axis
    cannonBall.quaternion.copy(initialRotation);

    cannonBall.castShadow = true;
    cannonBall.position.copy(
      barrel.position.clone().add(new THREE.Vector3(0, 2, -1))
    );
    scene.add(cannonBall);
  }

  if (axesHelper) {
    scene.remove(axesHelper);
  }
  axesHelper = new THREE.AxesHelper(5);
  scene.add(axesHelper);
  
  const angular_speed = vector.create(
    paramters.angular_speedX,
    paramters.angular_speedY,
    paramters.angular_speedZ
  );
  let physicsBall = new Ball(
    barrel.position.clone().add(new THREE.Vector3(0, 1.5, -1)),
    paramters.speed,
    angleXY,
    angleXZ,
    paramters.radius,
    0,
    paramters.mass,
    paramters.dragCoeff,
    angular_speed,
    paramters.resistanseCoeff,
    paramters.frictionCoeff
  );
  
  // Debug: Log ball creation details
  console.log('Ball created with:', {
    position: physicsBall.position,
    velocity: physicsBall.velocity,
    speed: paramters.speed,
    angleXY: angleXY,
    angleXZ: angleXZ,
    angular_speed: angular_speed
  });
  
  world.add(physicsBall);
  objectsToUpdate.push({
    cannonBall,
    physicsBall,
  });
  intersectObjects.push(cannonBall);
  
  // Release shooting lock - ball is now properly tracked
  isShootingInProgress = false;
  if (shootingLockTimeout) {
    clearTimeout(shootingLockTimeout);
    shootingLockTimeout = null;
  }
  console.log('Ball created and added - objectsToUpdate length:', objectsToUpdate.length, 'isShootingInProgress:', isShootingInProgress);
};

const removeBallsGreaterThanOne = () => {
  if (objectsToUpdate.length >= 1) {
    objectsToUpdate.forEach((e) => {
      scene.remove(e.cannonBall);
      
      // Properly dispose of GLB model resources
      if (e.cannonBall.isGroup) {
        // For GLB models (Groups), traverse and dispose of all meshes
        e.cannonBall.traverse((child) => {
          if (child.isMesh) {
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach(material => material.dispose());
              } else {
                child.material.dispose();
              }
            }
            if (child.geometry) {
              child.geometry.dispose();
            }
          }
        });
      } else {
        // For regular meshes, dispose normally
        if (e.cannonBall.material) {
          e.cannonBall.material.dispose();
        }
        if (e.cannonBall.geometry) {
          e.cannonBall.geometry.dispose();
        }
      }
      
      intersectObjects = intersectObjects.filter((i) => i !== e.cannonBall);
    });
      objectsToUpdate = [];
      // Reset ball removal flag (simplified)
      
      // Ball model will be updated to new position immediately
  }
};
const updateTarget = () => {
  // Update cannon position immediately - no delay needed
  // Keep target in fixed position - no need to move it
  // Target stays at (0, 30, 0)
  
  let newCannonPosition;
  let attempts = 0;
  let foundValidPosition = false;
  
  // Try to find a position that's far enough from the previous position
  while (attempts < MAX_ATTEMPTS && !foundValidPosition) {
    // Generate a new random position within bounds
    newCannonPosition = new THREE.Vector3(
      CANNON_BOUNDS.xMin + Math.random() * (CANNON_BOUNDS.xMax - CANNON_BOUNDS.xMin),
      CANNON_BOUNDS.yMin + Math.random() * (CANNON_BOUNDS.yMax - CANNON_BOUNDS.yMin),
      CANNON_BOUNDS.zMin + Math.random() * (CANNON_BOUNDS.zMax - CANNON_BOUNDS.zMin)
    );
    
    // Calculate distance from previous position
    const distanceFromPrevious = newCannonPosition.distanceTo(previousCannonPosition);
    
    console.log(`Attempt ${attempts + 1}: Distance from previous position: ${distanceFromPrevious.toFixed(2)} (required: ${MIN_CANNON_DISTANCE})`);
    console.log(`New position: (${newCannonPosition.x.toFixed(2)}, ${newCannonPosition.y.toFixed(2)}, ${newCannonPosition.z.toFixed(2)})`);
    
    if (distanceFromPrevious >= MIN_CANNON_DISTANCE) {
      foundValidPosition = true;
      console.log('Found valid position far enough from previous position');
    } else {
      attempts++;
      console.log('Position too close to previous, trying again...');
    }
  }
  
  // If we couldn't find a valid position after max attempts, use the last generated position
  if (!foundValidPosition) {
    console.log('Could not find position far enough from previous, using last generated position');
  }
  
  // Update cannon barrel position immediately
  barrel.position.copy(newCannonPosition);
  
  // Store this position as the new previous position
  previousCannonPosition.copy(newCannonPosition);
  
  // Update ball model position to match the new cannon position
  ensureBallModelVisible();
  
  // Force update ball model position to ensure proper alignment and visibility
  if (ballModel) {
    const ballPosition = barrel.position.clone().add(new THREE.Vector3(0, -8.5, -1));
    // Ensure ball is always above ground level (field is at y=0)
    ballPosition.y = Math.max(ballPosition.y, 2); // Minimum 2 units above ground
    ballModel.position.copy(ballPosition);
    ballModel.visible = true; // Make sure it's visible at the new position
    console.log('Ball model position updated to:', ballModel.position);
  }
  
  // Ensure target is in collision detection (it should always be)
  if (!intersectObjects.includes(target)) {
    intersectObjects.push(target);
    console.log('Target added back to collision detection');
  }
  
  console.log('Cannon moved to new position:', newCannonPosition);
  console.log('Distance from previous position:', newCannonPosition.distanceTo(previousCannonPosition).toFixed(2));
};

const updateWidgets = () => {
  successCount++;
  scoreWidget.innerHTML = successCount;
  console.log(`Success! Total successful kicks: ${successCount}`);
};

const checkGame = () => {
  if (numberOfBalls === 0 && objectsToUpdate.length === 0) {
    // Show results modal only after all balls are finished and no balls are in flight
    showResultsModal();
    isFinished = true;
  }
};

const checkWallCollisions = (object) => {
  const ball = object.cannonBall;
  const physicsBall = object.physicsBall;
  
  // Define wall boundaries (same as ad board positions)
  const leftWall = -150;   // Left ad board position
  const rightWall = 270;   // Right ad board position
  const backWall = -225;   // Back ad board position
  const frontWall = 800;   // Front boundary
  
  // Check if ball is hitting walls and bounce it back
  if (ball.position.x <= leftWall) {
    // Ball hit left wall - bounce back
    ball.position.x = leftWall + 1; // Move ball slightly away from wall
    physicsBall.position.x = leftWall + 1;
    physicsBall.velocity.x = Math.abs(physicsBall.velocity.x) * 0.8; // Bounce with energy loss
    console.log('Ball bounced off left wall');
  }
  
  if (ball.position.x >= rightWall) {
    // Ball hit right wall - bounce back
    ball.position.x = rightWall - 1; // Move ball slightly away from wall
    physicsBall.position.x = rightWall - 1;
    physicsBall.velocity.x = -Math.abs(physicsBall.velocity.x) * 0.8; // Bounce with energy loss
    console.log('Ball bounced off right wall');
  }
  
  if (ball.position.z <= backWall) {
    // Ball hit back wall - bounce back
    ball.position.z = backWall + 1; // Move ball slightly away from wall
    physicsBall.position.z = backWall + 1;
    physicsBall.velocity.z = Math.abs(physicsBall.velocity.z) * 0.8; // Bounce with energy loss
    // console.log('Ball bounced off back wall');
  }
  
  if (ball.position.z >= frontWall) {
    // Ball hit front wall - bounce back
    ball.position.z = frontWall - 1; // Move ball slightly away from wall
    physicsBall.position.z = frontWall - 1;
    physicsBall.velocity.z = -Math.abs(physicsBall.velocity.z) * 0.8; // Bounce with energy loss
    console.log('Ball bounced off front wall');
  }
};

const checkBallPosition = (ball) => {
  // Define exact playground boundaries based on ad board positions
  const playgroundLeft = -150;   // Left ad board position
  const playgroundRight = 270;   // Right ad board position  
  const playgroundBack = -225;   // Back ad board position
  const playgroundFront = 800;   // Front boundary (extended for camera)
  
  // Use reasonable buffer to prevent premature boundary detection
  const buffer = 30; // 30 unit buffer
  
  // Check if ball is within playground boundaries
  const isWithinBoundaries = (
    ball.position.x >= (playgroundLeft + buffer) &&
    ball.position.x <= (playgroundRight - buffer) &&
    ball.position.z >= (playgroundBack + buffer) &&
    ball.position.z <= (playgroundFront - buffer)
  );
  
  if (isWithinBoundaries) {
    return; // Ball is still within playground, continue
  } else {
    // Ball is outside playground boundaries - remove it immediately
    console.log('Ball went outside playground boundaries - removing ball');
    
    // Remove the ball immediately
    scene.remove(ball);
    
    // Properly dispose of GLB model resources
    if (ball.isGroup) {
      // For GLB models (Groups), traverse and dispose of all meshes
      ball.traverse((child) => {
        if (child.isMesh) {
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach(material => material.dispose());
            } else {
              child.material.dispose();
            }
          }
          if (child.geometry) {
            child.geometry.dispose();
          }
        }
      });
    } else {
      // For regular meshes, dispose normally
      if (ball.material) {
        ball.material.dispose();
      }
      if (ball.geometry) {
        ball.geometry.dispose();
      }
    }
    
    // Remove from tracking arrays
    objectsToUpdate = objectsToUpdate.filter((e) => e.cannonBall !== ball);
    intersectObjects = intersectObjects.filter((obj) => obj !== ball);
    isCameraChasing = false;
    console.log('Ball removed from boundary - objectsToUpdate length:', objectsToUpdate.length);
    
    // Show the ball model again
    ensureBallModelVisible();
    
    // Reset shot state for automatic restart
    shotedTaregt = [];
    currentShotState = 'none';
    goalPredictionActive = false;
    ballPassedThroughGoal = false;
    lastBallPosition = null;
    
    // Reset target to default state
    if (target) {
      target.material.color.set("#ffffff");
      if (!intersectObjects.includes(target)) {
        intersectObjects.push(target);
      }
    }
    
    console.log('Ball removed - ready for new shots');
  }
};

let previousAngle = 1.5707963268 * 2;
function rotateAboutPoint(obj, point, axis, theta) {
  obj.rotateOnAxis(axis, -previousAngle);
  obj.position.sub(point);
  obj.position.applyAxisAngle(axis, -previousAngle);
  obj.position.add(point);

  obj.position.sub(point);
  obj.position.applyAxisAngle(axis, theta);
  obj.position.add(point);

  obj.rotateOnAxis(axis, theta);
  previousAngle = theta;
}
rotateAboutPoint(
  flag,
  flagBase.position,
  new THREE.Vector3(0, 1, 0),
  paramters.windAngle
);

let shotedTaregt = [];
const clock = new THREE.Clock();
let oldElapsedTime = 0;
let goalPredictionActive = false;

// Shot state tracking to prevent multiple success/failure detections per shot
let currentShotState = 'none'; // 'none', 'missed', 'success', 'failure'

// Goal opening collision detection
let ballPassedThroughGoal = false;
let lastBallPosition = null;

// Global shooting lock to prevent multiple balls
let isShootingInProgress = false;
let shootingLockTimeout = null;

// Function to clean up stuck balls in objectsToUpdate
const cleanupStuckBalls = () => {
  if (objectsToUpdate.length > 0) {
    console.log('Cleaning up stuck balls in objectsToUpdate:', objectsToUpdate.length);
    objectsToUpdate.forEach((e) => {
      // Check if ball still exists in scene
      if (e.cannonBall && e.cannonBall.parent) {
        console.log('Removing stuck ball from scene');
        scene.remove(e.cannonBall);
        
        // Properly dispose of GLB model resources
        if (e.cannonBall.isGroup) {
          e.cannonBall.traverse((child) => {
            if (child.isMesh) {
              if (child.material) {
                if (Array.isArray(child.material)) {
                  child.material.forEach(material => material.dispose());
                } else {
                  child.material.dispose();
                }
              }
              if (child.geometry) {
                child.geometry.dispose();
              }
            }
          });
        } else {
          if (e.cannonBall.material) {
            e.cannonBall.material.dispose();
          }
          if (e.cannonBall.geometry) {
            e.cannonBall.geometry.dispose();
          }
        }
      }
    });
    
    // Clear the array
    objectsToUpdate = [];
    intersectObjects = intersectObjects.filter(obj => !objectsToUpdate.some(e => e.cannonBall === obj));
    isCameraChasing = false;
    
    // Show the ball model again
    ensureBallModelVisible();
    
    console.log('Stuck balls cleaned up - objectsToUpdate length:', objectsToUpdate.length);
  }
};

// Function to check if ball passes through goal opening
const checkGoalOpeningPass = (ballPosition, lastPosition) => {
  if (!lastPosition || !target) return false;
  
  const targetPosition = target.position;
  
  // Goal opening dimensions (same as in collision detection)
  const goalOpeningWidth = 35;
  const goalOpeningHeightBottom = 40;
  const goalOpeningHeightTop = 500;
  const goalOpeningOffsetY = 45;
  
  // Convert positions to local target coordinates
  const currentLocal = ballPosition.clone().sub(targetPosition);
  const lastLocal = lastPosition.clone().sub(targetPosition);
  
  // Check if ball trajectory crosses the goal opening plane (Z = 0 in target space)
  // The ball needs to be moving towards the target (negative Z direction)
  if (currentLocal.z > lastLocal.z) return false; // Ball moving away from target
  
  // Check if ball is within goal opening bounds when crossing the plane
  const isWithinWidth = Math.abs(currentLocal.x) <= goalOpeningWidth / 2;
  const isWithinHeight = currentLocal.y >= (goalOpeningOffsetY - goalOpeningHeightBottom) && 
                        currentLocal.y <= (goalOpeningOffsetY + goalOpeningHeightTop);
  
  // Check if ball crossed the target plane (Z = 0)
  const crossedTargetPlane = lastLocal.z > 0 && currentLocal.z <= 0;
  
  if (crossedTargetPlane && isWithinWidth && isWithinHeight) {
    console.log('GOAL! Ball passed through goal opening!');
    console.log('Ball position when crossing:', currentLocal);
    console.log('Goal opening bounds - Width:', goalOpeningWidth/2, 'Height:', goalOpeningOffsetY - goalOpeningHeightBottom, 'to', goalOpeningOffsetY + goalOpeningHeightTop);
    return true;
  }
  
  return false;
};

//const control = new OrbitControls(camera, canvas)

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  flagMaterial.uniforms.uTime.value = elapsedTime * paramters.windSpeed;
  const delteTime = elapsedTime - oldElapsedTime;
  world.update(delteTime);
  oldElapsedTime = elapsedTime;

  for (const object of objectsToUpdate) {
    // Store previous position for trajectory analysis
    const currentPosition = object.physicsBall.position.clone();
    
    object.cannonBall.position.copy(object.physicsBall.position);
    
    // Maintain vertical orientation while applying physics rotation
    // Start with the initial vertical rotation (90 degrees around Z-axis)
    const verticalRotation = new THREE.Quaternion();
    verticalRotation.setFromAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2);
    
    // Apply physics rotation on top of the vertical orientation
    // This allows the ball to rotate around its own axis while maintaining vertical orientation
    object.cannonBall.quaternion.copy(verticalRotation).multiply(object.physicsBall.quaternion);
    
    // Check if ball passed through goal opening (before other collision checks)
    if (!ballPassedThroughGoal && lastBallPosition && currentShotState === 'none') {
      if (checkGoalOpeningPass(currentPosition, lastBallPosition)) {
        ballPassedThroughGoal = true;
        currentShotState = 'success';
        
        // Show green color effect on target for success
        target.material.color.set("#00ff00");
        setTimeout(() => {
          target.material.color.set("#ffffff"); // Reset to white
        }, 500);
        
        // Remove target from collision detection temporarily so ball can pass through
        intersectObjects = intersectObjects.filter(obj => obj !== target);
        
        // Reset prediction flag
        goalPredictionActive = false;
        
        updateWidgets(); // Update success count
        updateTarget();
        checkGame();
      }
    }
    
    // Update last position for next frame
    lastBallPosition = currentPosition;
    
    // Check for wall collisions and bounce before other collision detection
    checkWallCollisions(object);
    
    checkBallPosition(object.cannonBall);
    rayOrigin = object.cannonBall.position;
    raycaster.set(rayOrigin, rayDirection);
    axesHelper?.position?.copy(object.cannonBall.position);
    axesHelper?.quaternion?.copy(object.cannonBall.quaternion);
    axesHelper.visible = paramters.axesHelper;
    
    // PREDICT if ball will be successful BEFORE collision detection
    if (!goalPredictionActive && target) {
      const ballPosition = object.cannonBall.position;
      const targetPosition = target.position;
      const distanceToTarget = ballPosition.distanceTo(targetPosition);
      
      // If ball is getting close to target
      if (distanceToTarget < 120) { // Increased from 80 to 120 units for earlier prediction
        const ballVelocity = object.physicsBall.velocity;
        const directionToTarget = targetPosition.clone().sub(ballPosition).normalize();
        const velocityDirection = ballVelocity.clone().normalize();
        
        // Check if ball is moving towards the target
        const dotProduct = directionToTarget.dot(velocityDirection);
        if (dotProduct > 0.6) { // Reduced from 0.8 to 0.6 for more lenient alignment (60% alignment)
          console.log('PREDICTING SUCCESS! Ball will likely hit target - preparing smooth transition...');
          goalPredictionActive = true;
          
          // PREPARE SETTINGS IN ADVANCE for smooth transition
          // No need to remove separate collision objects since we only use the target
          
          // Make the ball non-collidable with everything except target
          object.physicsBall.collisionFilterGroup = 0;
          object.physicsBall.collisionFilterMask = 0;
          
          // Show subtle hint that goal is coming
          target.material.color.set("#eeeeff"); // Very light blue hint
        }
      }
    }
    
    const intersects = raycaster.intersectObjects(intersectObjects, true);
    for (let intersect of intersects) {
      if (!shotedTaregt.includes(intersect.object)) {
        // Wall collisions are now handled in checkWallCollisions function
        
        // Check if it's the visual target - need to determine if hit open area or goal post structure
        if (intersect.object === target && currentShotState === 'none') {
          // Calculate the hit position relative to the target's center
          const targetPosition = target.position;
          const hitPoint = intersect.point;
          
          // Convert hit point to local target coordinates
          const localHitPoint = hitPoint.clone().sub(targetPosition);
          
          // Debug logging to understand hit position
          console.log('Ball hit target at local position:', localHitPoint);
          console.log('Target position:', targetPosition);
          console.log('Hit point:', hitPoint);
          
          // Target dimensions: 35 width x 60 height
          // Success region is ONLY the TOP area of the target (above the goalpost crossbar)
          // The red part at the bottom should NOT count as success
          const goalOpeningWidth = 35; // Full width of target
          const goalOpeningHeightBottom = 40; // Height of the top region only
          const goalOpeningHeightTop = 500;
          const goalOpeningOffsetY = 45; // Positioned to cover only the TOP area (above crossbar)
          
          // Check if hit is within the goal post opening (success area)
          const isInGoalOpening = 
            Math.abs(localHitPoint.x) <= goalOpeningWidth / 2 && // Within opening width
            localHitPoint.y >= goalOpeningOffsetY - goalOpeningHeightBottom && // Above bottom of opening
            localHitPoint.y <= goalOpeningOffsetY + goalOpeningHeightTop;   // Below top of opening
          
          // Debug logging for success region calculation
          console.log('Success region check:');
          console.log('  Width check:', Math.abs(localHitPoint.x), '<=', goalOpeningWidth / 2, '=', Math.abs(localHitPoint.x) <= goalOpeningWidth / 2);
          console.log('  Bottom check:', localHitPoint.y, '>=', goalOpeningOffsetY - goalOpeningHeightBottom, '=', localHitPoint.y >= goalOpeningOffsetY - goalOpeningHeightBottom);
          console.log('  Top check:', localHitPoint.y, '<=', goalOpeningOffsetY + goalOpeningHeightTop, '=', localHitPoint.y <= goalOpeningOffsetY + goalOpeningHeightTop);
          console.log('  Is in goal opening:', isInGoalOpening);
          
          if (isInGoalOpening) {
            // SUCCESS - Hit the TOP area of the target (above the goalpost crossbar)
            console.log('GOAL! Ball hit the TOP region of the target!');
            currentShotState = 'success';
            shotedTaregt.push(intersect.object);
            
            // Show green color effect on target for success
            target.material.color.set("#00ff00");
            setTimeout(() => {
              target.material.color.set("#ffffff"); // Reset to white
            }, 500);
            
            // Remove target from collision detection temporarily so ball can pass through
            intersectObjects = intersectObjects.filter(obj => obj !== target);
            // Note: Target will be added back to collision detection in updateTarget() after 1 second
            
            // Reset prediction flag
            goalPredictionActive = false;
            
            updateWidgets(); // Update success count
            updateTarget();
            checkGame();
          } else {
            // FAILURE - Hit the goal post structure (red regions)
            console.log('MISS! Ball hit the goal post structure');
            currentShotState = 'failure';
            
            // Show red color effect on target for failure
            target.material.color.set("#ff0000");
            setTimeout(() => {
              target.material.color.set("#ffffff"); // Reset to white
            }, 500);
            
            ensureBallModelVisible();
            object.physicsBall.fraction(intersect);
          }
        }
        // Other objects (ground, etc.) - mark as missed if not already determined
        else if (intersect.object.geometry.type !== "PlaneGeometry" && currentShotState === 'none') {
          console.log('MISS! Ball hit ground or other object');
          currentShotState = 'missed';
          ensureBallModelVisible();
          object.physicsBall.fraction(intersect);
        }
      }
    }
  }
  if (isObjectLoaded) {
    updateCannon();
  }
  
  // Continuous game state check to ensure game ends when it should
  if (!isFinished && numberOfBalls === 0 && objectsToUpdate.length === 0) {
    checkGame();
  }
  if (objectsToUpdate.slice(-1)[0]?.cannonBall) {
    chasingCamera.position.copy(
      objectsToUpdate
        .slice(-1)[0]
        ?.cannonBall.position.clone()
        .add(new THREE.Vector3(0, 0, 50))
    );
    chasingCamera.lookAt(objectsToUpdate.slice(-1)[0].cannonBall.position);
  }
  if (isCameraChasing) {
    renderer.render(scene, chasingCamera);
  } else {
    renderer.render(scene, camera);
  }
  requestAnimationFrame(tick);
};

tick();
